import PathwaysHeader from './component'
export default PathwaysHeader
